import { render } from "./AddDoctorTimeslots.vue?vue&type=template&id=4d7e20be&scoped=true"
import script from "./AddDoctorTimeslots.vue?vue&type=script&lang=js"
export * from "./AddDoctorTimeslots.vue?vue&type=script&lang=js"

import "./AddDoctorTimeslots.vue?vue&type=style&index=0&id=4d7e20be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d7e20be"]])

export default __exports__